import React from 'react';
import {
  register_employees_csv,
  register_employees_xlsx,
  deactivate_employees_csv,
  deactivate_employees_xlsx,
  register_family_members_csv,
  register_family_members_xlsx,
  pre_employment_bluk_upload_xlsx,
  team_upload_csv,
  team_upload_xlsx,
  member_upload_xlsx,
  member_upload_csv,
  ppmc_bluk_upload_xlsx
} from './links';
import {
  employeeDataApi,
  StepathonApi
} from '../services';

const DRAGGER_CONTENT = {
  employee_register: {
    title: 'Employee registration/ addition',
    description: 'You can bulk register customers using CSV / XLSX file.',
    dragger_title: 'Upload Employee Registration CSV / XLSX File',
    href: [register_employees_csv, register_employees_xlsx],
    faqs: [
      {
        title: 'How can I delete an employee?',
        description: 'If you have a few employees for deletion, you can search for a specific employee and mark for the deletion, or you can use the bulk deletion feature and delete the user.',
      },
      {
        title: 'How can I delete an employee?',
        description: 'If you have a few employees for deletion, you can search for a specific employee and mark for the deletion, or you can use the bulk deletion feature and delete the user.',
      },
    ],
  },
  deactivate: {
    title: 'Deactivate employees in bulk',
    description: 'You can bulk deactivate employees using CSV / XLSX file.',
    dragger_title: 'Upload Deactivate Employee CSV / XLSX File',
    href: [deactivate_employees_csv,deactivate_employees_xlsx]
  },
  family_register: {
    title: 'Family registration',
    description: 'You can bulk upload family registration using CSV / XLSX file.',
    dragger_title: 'Upload Family Data CSV / XLSX File',
    href: [register_family_members_csv, register_family_members_xlsx],
  },
  pre_emp_bulk_upload: {
    title: 'Pre employment checkups',
    description: 'You can bulk register employees for checkups using XLSX file.',
    dragger_title: 'Upload pre employment checkups XLSX File here',
    href: [pre_employment_bluk_upload_xlsx]
  },
  ppmc_bulk_upload: {
    title: 'Pre-Policy Medical Checkups',
    description: 'You can bulk register employees for checkups using XLSX file.',
    dragger_title: 'Upload pre-policy medical checkups XLSX File here',
    href: [ppmc_bluk_upload_xlsx]
  },
  stepathon_team_bulk_register: {
    title: 'Upload new teams',
    description: 'You can bulk upload new teams using CSV / XLSX file.',
    dragger_title: 'Upload New Teams Data CSV / XLSX File',
    href: [team_upload_csv,team_upload_xlsx]
  },
  re_upload_stepathon_content : {
    title: 'Re-upload teams',
    description: 'You can bulk upload new teams using CSV / XLSX file.',
    dragger_title: 'Re-upload Teams Data CSV / XLSX File',
    href: [team_upload_csv,team_upload_xlsx]
  },
  stepathon_member_bulk_register: {
    title: 'Upload new members',
    description: 'You can bulk upload new members list using CSV / XLSX file.',
    dragger_title: 'Upload New Members Data CSV / XLSX File',
    href: [member_upload_csv,member_upload_xlsx]
  },
  re_upload_stepathon_member_content : {
    title: 'Re-upload members',
    description: 'You can bulk re-upload new member using CSV / XLSX file.',
    dragger_title: 'Re-upload Members Data CSV / XLSX File',
    href: [member_upload_csv,member_upload_xlsx]
  }
};

const UPDATE_EMPLOYEE_LABELS = ['FIRST NAME', 'LAST NAME', 'MOBILE NUMBER', 'EMAIL', 'DATE OF BIRTH' ,'EMPLOYEE ID', 'DEPARTMENT', 'LOCATION']
const UPDATE_EMPLOYEE_NAMES = ['first_name', 'last_name', 'mobile_number', 'email', 'date_of_birth' ,'employee_id', 'sponsor_department', 'sponsor_location']
const ADD_EMPLOYEE_PLACEHOLDER = ['Please add first name here','Please add last name here', 'Please add mobile number here', 'Please add email here', 'Please add here date of birth','Please add employee id here', 'Please add department here', 'Please add location here']

const UPLOAD_QUERY_STATUS = {
  employee_addition : 'registration',
  employee_deactivation : 'deactivation',
  family_addition : 'registration',
  preEmp_bulk_uploader: 'registration',
  stepathon_team_bulk_uploader: 'registration',
  stepathon_member_bulk_uploader: 'uploaded'
}

const CANCEL_QUERY_STATUS = {
  employee_addition : 'Employee addition',
  employee_deactivation : 'Employee deactivation',
  family_addition : 'Family registration',
  preEmp_bulk_uploader: 'Pre employement',
  stepathon_team_bulk_uploader: 'Stepathon',
  stepathon_member_bulk_uploader: 'Stepathon'
}

const DISABLE_ICON = {
  employee_addition : 'showAddIcon',
  employee_deactivation : 'showDeleteIcon',
  family_addition : 'showFamilyIcon'
}

const PRE_EMP_BULK_CHECK = 'Pre employement bulk checkups';
const PPMC_BULK_CHECK = 'Pre-Policy Medical bulk checkups';

const EMPLOYEE_PAGE_CONTENT = {
  employee_addition: {
    //employee_register
    title: 'Add Employee',
    breadcrumb: {
      text: 'Add Employee',
      link: '/employee-registration',
    },
    tableHeaders: ['id', 'first name', 'last name', 'email', 'location', 'dob', 'gender', 'department','isd_code', 'mobile', 'vip', 'entity_name', 'policy_id', 'policy_name',	'member_id',	'policy_start_date',	'policy_end_date', 'national_identity_number', 'grade'],
    headers : ['employee_code',	'first_name',	'last_name',	'email',	'employee_office_location',	'date_of_birth',	'gender',	'department', 'isd_code', 'mobile_number', 'vip',	'entity_name', 'policy_id', 'policy_name',	'member_id', 'policy_start_date',	'policy_end_date', 'national_identity_number', 'grade'],
    recent_uploads_headers : ['employee_code',	'first_name',	'last_name',	'email',	'employee_office_location',	'date_of_birth',	'gender',	'sponsor_department', 'isd_code', 'mobile_number', 'vip',	'entity_name', 'policy_id', 'policy_name',	'member_id',	'policy_start_date',	'policy_end_date', 'national_identity_number', 'grade'],
    request: employeeDataApi.register_employees,
    fetch_recent_upload_details: employeeDataApi.recent_uploads_details,
    upload_status: employeeDataApi.upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data registered successfully', 'Employees data registration failed'],
    id_name: 'customer_data_upload_id'
  },
  employee_deactivation: {
    //deactivation
    title: 'Deactivate Employees',
    breadcrumb: {
      text: 'Deactivate Employees',
      link: '/deactivate-employees',
    },
    headers:['email'],
    tableHeaders : [ 'email'],
    recent_uploads_headers: ['email'],
    request: employeeDataApi.delete_employees,
    fetch_recent_upload_details: employeeDataApi.deactivate_recent_uploads_details,
    upload_status: employeeDataApi.deactivate_upload_status,
    upload_status_metrics: ['Employees', 'Employees data deactivation in progress', 'Employees deactivated successfully', 'Employees data deactivation failed'],
    id_name: 'customer_data_deletion_id'
  },
  family_addition: {
    //family_register
    title: 'Family Members',
    breadcrumb: {
      text: 'Family Members',
      link: '/family-registration',
    },
    tableHeaders : [ 'email', 'first name', 'last name', 'dob', 'relation', 'gender', 'policy_id', 'policy_name',	'member_id',	'policy_start_date',	'policy_end_date', 'national_identity_number', 'grade', 'authorised_dependent'],
    headers:['email', 'first_name', 'last_name', 'date_of_birth', 'relation', 'gender', 'policy_id', 'policy_name',	'member_id',	'policy_start_date',	'policy_end_date', 'national_identity_number', 'grade', 'authorised_dependent'],
    recent_uploads_headers:['email', 'first_name', 'last_name', 'date_of_birth', 'relation', 'gender', 'policy_id', 'policy_name',	'member_id',	'policy_start_date',	'policy_end_date', 'national_identity_number', 'grade', 'authorised_dependent'],
    request: employeeDataApi.register_family_members,
    fetch_recent_upload_details: employeeDataApi.recent_uploads_details,
    upload_status: employeeDataApi.upload_status,
    upload_status_metrics: ['Family members', 'Family members data in progress', 'Family members registered successfully', 'Family members registration failed'],
    id_name: 'customer_data_upload_id'
  },
  preEmp_bulk_uploader: {
    title: 'Pre employement bulk checkups',
    breadcrumb: {
      text: 'Add Bulk',
      link: '/pre-employee-checkup',
      r_link: '/pre-employee-checkup/bulk-upload',
    },
    tableHeaders: ['name', 'gender', 'date_of_birth', 'mobile', 'email', 'date_of_appointment', 'dc_name_and_location', 'date_of_joining', 'employee_address', 'aadhaar_card','job_involves', 'other_details', 'entity_name'],
    headers : ['Name',	'Gender',	'DOB',	'Mobile Number',	'Email',	'Date of Appointment',	'DC Name and Location', 'Date of Joining', 'Employee Address', 'Aadhaar Card No',	'Job Involves', 'Other details', 'Entity Name'],
    recent_uploads_headers : ['name',	'gender',	'date_of_birth',	'mobile_number',	'email',	'date_of_appointment', 'dc_name_and_location', 'date_of_joining',	'employee_address', 'aadhaar_card_no', 'job_involves',	'other_details', 'entity_name'],
    request: employeeDataApi.preEmp_bulk_upload,
    fetch_recent_upload_details: employeeDataApi.pre_emp_recent_uploads_details,
    upload_status: employeeDataApi.preEmp_upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data registered successfully', 'Employees data registration failed'],
    id_name: 'customer_data_upload_id',
    type: 'PreEmployeeAppointment'
  },
  ppmc_bulk_uploader: {
    title: 'Pre-Policy Medical bulk checkups',
    breadcrumb: {
      text: 'Add Bulk',
      link: '/ppmc-employee-checkup',
      r_link: '/ppmc-employee-checkup/bulk-upload',
    },
    tableHeaders: ['name', 'gender', 'date_of_birth', 'mobile', 'email', 'date_of_appointment', 'dc_name_and_location', 'date_of_joining', 'employee_address', 'aadhaar_card','job_involves', 'other_details', 'entity_name'],
    headers : ['Name',	'Gender',	'DOB',	'Mobile Number',	'Email',	'Date of Appointment',	'DC Name and Location', 'Date of Joining', 'Employee Address', 'Aadhaar Card No',	'Job Involves', 'Other details', 'Entity Name'],
    recent_uploads_headers : ['name',	'gender',	'date_of_birth',	'mobile_number',	'email',	'date_of_appointment', 'dc_name_and_location', 'date_of_joining',	'employee_address', 'aadhaar_card_no', 'job_involves',	'other_details', 'entity_name'],
    request: employeeDataApi.preEmp_bulk_upload,
    fetch_recent_upload_details: employeeDataApi.pre_emp_recent_uploads_details,
    upload_status: employeeDataApi.preEmp_upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data registered successfully', 'Employees data registration failed'],
    id_name: 'customer_data_upload_id',
    type: 'PpmcAppointment'
  },
  stepathon_team_bulk_uploader: {
    title: 'Create new teams',
    breadcrumb: {
      text: 'Uploading teams data',
      link: '/stepathon',
      r_link: '/stepathon/team-upload',
    },
    tableHeaders: ['team_name', 'email'],
    headers : ['TEAM_NAME', 'EMAIL'],
    request: StepathonApi.stepathon_team_bulk_upload,
    upload_status: StepathonApi.stepathon_team_upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data registered successfully', 'Employees data registration failed'],
    id_name: 'customer_data_upload_id'
  },
  re_upload_stepathon_upload : {
    title: 'Re-upload teams',
    breadcrumb: {
      text: 'Re-uploading teams data',
      link: '/stepathon',
      r_link: '/stepathon/team-upload',
    },
    tableHeaders: ['team_name', 'email'],
    headers : ['TEAM_NAME', 'EMAIL'],
    request: StepathonApi.stepathon_team_bulk_upload,
    upload_status: StepathonApi.stepathon_team_upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data registered successfully', 'Employees data registration failed'],
    id_name: 'customer_data_upload_id'
  },
  stepathon_member_bulk_uploader: {
    title: 'Create new members',
    breadcrumb: {
      text: 'Uploading member data',
      link: '/stepathon',
      r_link: '/stepathon/member-upload',
    },
    tableHeaders: ['email'],
    headers : ['EMAIL'],
    request: StepathonApi.stepathon_member_bulk_upload,
    upload_status: StepathonApi.stepathon_team_upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data uploaded successfully', 'Employees data upload failed'],
    id_name: 'customer_data_upload_id'
  },
  re_upload_stepathon_member_upload : {
    title: 'Re-upload members',
    breadcrumb: {
      text: 'Re-uploading member data',
      link: '/stepathon',
      r_link: '/stepathon/member-upload',
    },
    tableHeaders: ['email'],
    headers : ['EMAIL'],
    request: StepathonApi.stepathon_member_bulk_upload,
    upload_status: StepathonApi.stepathon_team_upload_status,
    upload_status_metrics: ['Employees', 'Employees data in progress', 'Employees data uploaded successfully', 'Employees data upload failed'],
    id_name: 'customer_data_upload_id'
  }
};

const ALLOWED_RELATION_LIMIT = {'father':1, 'mother':1, 'father in law':1, 'mother in law':1, 'brother':100, 'sister':100, 'son':100, 'daughter':100, 'wife':1, 'husband':1}
const INIT_RELATIONS = { father: 0, mother: 0, 'father in law': 0, 'mother in law': 0, brother: 0, sister: 0, son: 0, daughter: 0, wife: 0, husband: 0 }

const FAQS = {
  add: [
    {
      title: 'How do we add an employee?',
      description:
        'You need to bulk upload the employees using excel sheets. Download the sample file and populate the data as per the mentioned columns and save the data in the CSV/xlsx format and upload the same file.',
    },
    {
      title: 'Are there any mandatory fields while adding the Employee?',
      description: 'Yes, an employee’s first name and official email id are mandatory while adding a new employee.',
    },
    {
      title: 'What should I do if I don’t have data for few columns mentioned in the sample file?',
      description:
        'You should leave them empty and do not use NA or any other filler. But it’s good to have other column information as it will help in showing detailed analysis based on department, location, age, gender, etc.',
    },
    {
      title: 'What are do’s and don’ts while adding the employee data?',
      description: 'Below are the dos and don’ts which should be taken care of:',
      pointers: [[
        <div className='inline-block'><span className='font-semibold'>First name</span> is mandatory for registering an employee.</div>,
        <div className='inline-block'><span className='font-semibold'>First name, Last name</span> should not contain any special characters apart from space if required.</div>,
         <div className='inline-block'>No prefixes like Mr/Ms/Mrs are allowed (For example, Mr. Virender Sehwag you should put Virender under the first name and Sehwag under the last name. In the case of Mr. Virender Kumar Sehwag you should put Virender Kumar under first name and Sehwag under last name).</div>,
         <div className='inline-block'><span className='font-semibold'>Employee official</span> email is mandatory and should be - In the format like name@company.com/in without any spaces before or after.</div>,
         <div className='inline-block'>For <span className='font-semibold'>employee location,</span> please provide the location of the Employee you would like to see on your corporate dashboard.</div>,
         <div className='inline-block'>For adding employee locations, please use standard locations only and take care of duplication of locations like Bangalore - Bengaluru, Gurgaon- Gurugoan/Gurugram, upper case, and lower case - Delhi - delhi.</div>,
         <div className='inline-block'>Please avoid lengthy locations like Bengaluru building 12B instead; you can mention Bglr 12B for your reference.</div>,
         <div className='inline-block'>In case you have only one office in one city, you can provide the city name as location. In case you have multiple offices in the same city, then you can provide the location name instead of the city name.</div>,
         <div className='inline-block'><span className='font-semibold'>Date of birth</span> in DD-MM-YYYY like (06-06-1990).</div>,
         <div className='inline-block'><span className='font-semibold'>Gender</span> is case sensitive and should be mentioned as Male, Female only (F/M, female/male is not accepted by the system)</div>,
         <div className='inline-block'>For adding <span className='font-semibold'>department,</span> please use the full form e.g. HR can be mentioned as Human Resource or IT can be as Information Technology.</div>,
         <div className='inline-block'>Use of & symbol should not be restricted in departments.</div>,
         <div className='inline-block'><span className='font-semibold'>Mobile Number</span> - Only the 10 digits without +91, give only the personal mobile numbers, not the office extensions. (90000 90000, +9190000 90000, +919000090000 is not accepted by the system)</div>,
         <div className='inline-block'><span className='font-semibold'>VIP</span> tagging is generally used for leadership management. If you wish to mention the tagging, please use Yes/No or you can leave the column empty.</div>,
         <div className='inline-block'><span className='font-semibold'>Entity name</span> column can be used to update additional information about the employees, like if the employees belong to different entities or different cost centers you can mention while adding the Employee.</div>,
      ]],
    },
    {
      title: 'Will there be an error message if the file is not in CSV/XLSX format?',
      description: 'Yes, you will receive an error message as a pop-up (the uploaded file is not in the correct format).',
    },
    {
      title: 'Will, there be an error if I miss any of the headers in the data file?',
      description: 'Yes, you will receive an error message as a pop-up.'
    },
    {
      title: 'What will happen once my data is uploaded?',
      description: 'Once, the data is uploaded, the system starts validating the data.'
    },
    {
      title: ' What happens if the data fails the validation?',
      description: 'If the validation fails you will get the error report on the screen. You need to rectify the error and reupload the data or you can proceed with the error data but the data will not be processed.',
    },
    {
      title: 'What happens once the data passes validation?',
      description: 'Once, the data passes the validation the next step is to process the data. You need to click on proceed button. The data will start getting registered in our database.',
    },
    {
      title: 'How will I know if data is successfully registered?',
      description:
        'While the data is getting processed you will see the real-time update on your screen, how many employees are successfully registered, and how many are failed to register. Also, once the data processing is completed you will receive an email for the same.',
    },
    {
      title: 'What happens if the data fails to register?',
      description: 'Once the data is uploaded and if it fails to register, we will send a failure mail along with the data in the excel sheet attached.',
    },
    {
      title: 'How will I get to know why my data has failed to register?',
      description: 'You will receive an email along with an excel sheet, and an error message will be added against each Employee’s data that has failed.',
    },
    {
      title: 'How do I register the failed data?',
      description:
        'Once you receive the error report, fix all the data errors, and populate the correct data on the sample file, save the file and upload it again. You will receive the mail once the data is registered',
    },
    {
      title: 'Do I need to upload the whole data again or only failed ones?',
      description: 'No, you need to only upload the failed data.',
    },
    {
      title: 'What kinds of errors can we get while registering the data?',
      description: 'Below is the list of errors:',
      pointers: [[
        <div className='inline-block'><span className='font-semibold'>Email id already exists-</span> This means the email id which you are trying to register is already registered with some other employee of your organization.</div>,
        <div className='inline-block'><span className='font-semibold'>Employee code already exists-</span> This means the employee code you are trying to add is already registered with some other employee of your organization</div>,
        <div className='inline-block'><span className='font-semibold'>The mobile number is already taken-</span> This means the mobile number is already registered with some employee.</div>,
        <div className='inline-block'><span className='font-semibold'>Mobile number invalid-</span> this means the mobile number is &lt; 10 digits or &gt; 10 digits</div>,
        <div className='inline-block'><span className='font-semibold'>Invalid email address-</span> this means the email address is not in the correct format.</div>,
        <div className='inline-block'><span className='font-semibold'>DOB incorrect/invalid-</span> If the DOB is not updated in DD-MM-YYYY format, the system will not accept it.</div>,
        <div className='inline-block'><span className='font-semibold'>Syntax error-</span> if your file has special characters apart from accepted columns you will receive the error message.</div>,
      ]],
    },
    {
      title: 'What is the use of VIP tagging?',
      description:
        'VIP tagging is used for leadership or senior management employees. Also, whenever they schedule their appointments related to health checks, we will be able to assign a member to them who can help them with the process.',
    },
  ],
  deactivate: [
    {
      title: 'How can I deactivate an employee?',
      description: 'If you have a few employees for deactivation you can either search for a specific employee and click on deactivate employee or you can use the bulk deactivation feature and deactivate the employee.',
    },
    {
      title: 'What is the difference between single employee deactivation and bulk deactivation?',
      description: 'Single deactivation is used if you have few employees to deactivate, and bulk deactivation is used to deactivate huge employee data. But you can also use bulk deactivation for few employees.',
    },
    {
      title: 'How does this bulk option works?',
      description: 'For bulk deactivation, all you need to do is to download the sample file and populate the official email ids of the employees and save the file, and upload.',
    },
    {
      title: 'Is there any mandatory field while deactivating the employee?',
      description: 'Yes, an employee’s official email id is mandatory while deactivating an employee.',
    },
    {
      title: 'Will I receive a confirmation once I upload the data for deactivation?',
      description: 'Yes, once the data is uploaded, a confirmation mail is sent to the respective HR and CSM along with the OPS team.',
    },
    {
      title: 'How will I know that my data has been deactivated?',
      description:
        'Once the employee data for deactivation is uploaded, you will receive a mail. The mail will contain details like total employees uploaded for deactivation, the number of employees deactivated, and the number of employees who failed.',
    },
    {
      title: 'How will I know why the data did not get deactivated?',
      description: 'The failure report will contain error details against each employee.',
    },
    {
      title: 'What kind of error report will be generated?',
      description:
        'For employee deactivation, if the email used to deactivate an employee is not the same which was used to register, the deactivation activity will not be performed, and you will receive an error Email-id did not found/registered.',
    },
    {
      title: 'How long does it take to deactivate the employee?',
      description: 'The employee’s profile gets deactivated immediately.',
    },
    {
      title: 'If I deactivate the employee by mistake, can I undo it?',
      description: 'No, you cannot change the status, you need to reach out to your respective customer success manager and they will help you.',
    },
  ],
  update: [
    {
      title: 'What is the update feature used for?',
      description: 'Update feature can be used for updating employee and dependent details like:',
      pointerHeaders: ['Employees', 'Dependent'],
      pointers: [['First and Last name', 'Mobile Number', 'Email Id', 'Gender', 'VIP tagging', 'Employee Id', 'Location, department, shift'], ['First and Last name', 'DOB', 'Relationship']],
    },
    {
      title: 'How can I update employee details?',
      description: 'Follow the below steps:',
      pointers: [['Search the Employee using his/her name or email, or employee code', 'Click on the pencil icon (edit)', 'Update the employee details', 'Then click on save']],
    },
    {
      title: 'How can I update family member details?',
      description: 'Follow below steps',
      pointers: [['Search the employee using his/her name or email or employee code', 'Click on the pencil icon (edit)', 'You will see the family member profile below the employee profile', 'Click on the pencil icon (edit) for whichever family member you need to edit the details', 'Update the dependent details', 'Then click on save']]
    },
    {
      title: 'How will I know if my employee details are updated?',
      description: 'Once you click on save on the right top corner, you will see and response message (Employee/ Family member data has been updated)',
    },
    {
      title: 'Do we have a bulk update option?',
      description: 'We do not have a bulk update option.',
    },
    {
      title: 'Do we have an update option for family members?',
      description: 'Yes, this feature is applicable to both employees and family members.',
    },
  ],
  add_family: [
    {
      title: 'How do I add a family member?',
      description: 'Download the sample file, populate the data as per column headings, save and upload.',
    },
    {
      title: 'Are there any mandatory fields while adding the Employee?',
      description: 'Yes, an email (Employee’s email), family member’s first name, relationship, and gender are mandatory while adding a new employee.',
    },
    {
      title: 'What should I do if I don’t have data for few columns mentioned in the sample file?',
      description: 'You should leave them empty and do not use NA or any other fillers.',
    },
    {
      title: 'What are do’s and don’ts while adding the employee data?',
      description: 'Below are the dos and don’ts which should be taken care of:',
      pointers: [[
        <div className='inline-block'><span className='font-semibold'>Email</span> means Employee’s email, and it’s is mandatory.</div>,
        <div className='inline-block'>The Employee for whom you want to add a family member should be registered in our database before registering the family member.</div>,
        <div className='inline-block'>Employee’s email id should be mentioned same as was provided during the employee registration.</div>,
        <div className='inline-block'><span className='font-semibold'>First name</span> is mandatory while adding a family member.</div>,
        <div className='inline-block'>Family member’s <span className='font-semibold'>first name, last name</span> should not contain any special characters apart from space if required, and no prefixes like Mr/Ms/Mrs are allowed (For example, Mr. Virender Sehwag you should put Virender under the first name and Sehwag under the last name. In the case of Mr. Virender Kumar Sehwag you should put Virender Kumar under first name and Sehwag under last name.)</div>,
        <div className='inline-block'>Date of birth in DD-MM-YYYY like (06-06-1990).</div>,
        <div className='inline-block'>Family member’s <span className='font-semibold'>relationship</span> is mandatory and is case sensitive.</div>,
        <div className='inline-block'>Gender should be mentioned as Male, Female, and is case sensitive (F/M, female/male is not accepted by the system)</div>,
        <div className='inline-block'>In the case of Mother or father in law, the relationship should be mentioned as Mother in law, Father in law, no use of special character like - will be accepted by the system</div>,
      ]],
    },
    {
      title: 'Can I add a family member without registering an employee?',
      description:
        'No, you cannot. You need to first register the Employee, and then you can add their family member. Each family member is associated with an employee with their guardian id. Employee’s email id is the guardian id of the family member.',
    },
    {
      title: 'How many family members can an employee have?',
      description: 'An employee can have a maximum of 8 family members.',
    },
    {
      title: 'What relations can be added?',
      description: 'Husband, Wife, Mother, Father, Daughter, Son, Mother in law, Father in law, Sister, brother.',
    },
    {
      title: 'Do we have capping on relations?',
      description:
        'Yes, we have a capping for relations like Husband, Wife, Mother, Father, Mother in law, Father in law, and can be added 1 per employee whereas Daughter, Son, Brother, Sister can be >1 per employee.',
    },
    {
      title: 'Will there be an error message if the file is not in CSV / XLSX format?',
      description: 'Yes, you will receive an error message on the right top corner (the wrong file Uploaded).',
    },
    {
      title: 'How will I know my data is successfully registered?',
      description:
        'Once the data is uploaded, you will receive a pop-up of the successfully uploaded files, and also, once the data is registered/added in the database, a confirmation mail is sent to the respective HR and CSM along with the OPS team.',
    },
    {
      title: 'What happens if the data fails to register?',
      description: 'Once the data is uploaded and if it fails to register, we will send a failure mail along with the data in the excel sheet attached.',
    },
    {
      title: 'How will I get to know why my data has failed to register?',
      description: 'You will receive an email along with an excel sheet, and an error message will be added against each Employee’s data that has failed.',
    },
    {
      title: 'How do I register the failed data?',
      description:
        'You will receive the error report, fixes all the errors, and populate the correct data on the sample format file, save the file and upload it. You will receive the mail once the data is registered.',
    },
    {
      title: 'What all kinds of errors can we get while registering the data?',
      description: 'Below is the list of errors:',
      pointers: [[
        <div className='inline-block'><span className='font-semibold'>Family Member limit exceeded-</span> if the number of family members added is 8 and you try to add 9th member, you will receive this error.</div>,
        <div className='inline-block font-semibold'>Invalid Date of birth</div>,
        <div className='inline-block'><span className='font-semibold'>The relation is not included in the list-</span> if the relations mentioned in the data are not as per the list mentioned above, you will receive this error.</div>,
        <div className='inline-block'><span className='font-semibold'>Email id does not exist- </span>if the Employee is not registered in the system and you try to register his family member, you will receive this error.</div>,
        <div className='inline-block'><span className='font-semibold'>The relationship already exists-</span> if you are trying to add the same relation for the second time, you will receive this error. This error holds good for relations like Mother, Father, Wife, Husband, and Mother in law, Father in law.</div>,
        <div className='inline-block'><span className='font-semibold'>Invalid gender-</span> if the gender is mentioned as F/M</div>,
        <div className='inline-block'><span className='font-semibold'>Gender must be present-</span> in case you have not mentioned the gender</div>,
      ]],
    },
  ],
};

export {
  DRAGGER_CONTENT,
  EMPLOYEE_PAGE_CONTENT,
  UPDATE_EMPLOYEE_LABELS,
  UPDATE_EMPLOYEE_NAMES,
  ADD_EMPLOYEE_PLACEHOLDER,
  ALLOWED_RELATION_LIMIT,
  INIT_RELATIONS,
  FAQS,
  UPLOAD_QUERY_STATUS,
  CANCEL_QUERY_STATUS,
  DISABLE_ICON,
  PRE_EMP_BULK_CHECK,
  PPMC_BULK_CHECK
};
